export const postMessage = ({ message }) => {
  if (window.opener) {
    window.opener.postMessage(message);
  }

  window.api?.postMessage?.(message);
};
